module.exports = __webpack_public_path__ + "img/aboutmain.0c829bfa.png";